export class Document {
    constructor(
        public id: number,
        public user_id: number,
        public signataire_id: number,
        public type: string,
        public name?: string,
        public path?: string,
        public datesave?: Date,
        public dateedit?: Date
    ){
        this.id = id;
        this.user_id = user_id;
        this.signataire_id = signataire_id;
        this.type = type;
    }
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/document.ts